/**
 * Plugin de gestion centralisée des erreurs
 * Affiche des notifications utilisateur et log les erreurs
 */
export default {
  install(Vue) {
    /**
     * Gestionnaire d'erreur global
     */
    Vue.prototype.$handleError = function(error, context = '') {
      console.error(`[Error ${context}]:`, error);

      let message = 'Une erreur est survenue';
      
      if (error.response) {
        // Erreur de réponse du serveur
        switch (error.response.status) {
          case 400:
            message = 'Requête invalide';
            break;
          case 401:
            message = 'Non autorisé - Veuillez vous reconnecter';
            break;
          case 403:
            message = 'Accès interdit';
            break;
          case 404:
            message = 'Ressource non trouvée';
            break;
          case 500:
            message = 'Erreur serveur - Veuillez réessayer plus tard';
            break;
          default:
            message = error.response.data?.message || 'Une erreur est survenue';
        }
      } else if (error.request) {
        // Pas de réponse du serveur
        message = 'Impossible de contacter le serveur';
      } else {
        // Erreur de configuration
        message = error.message || 'Une erreur est survenue';
      }

      // Afficher la notification (compatible avec votre système actuel)
      if (this.$root.$emit) {
        this.$root.$emit('show-error', message);
      }

      return message;
    };

    /**
     * Gestionnaire de succès
     */
    Vue.prototype.$handleSuccess = function(message) {
      if (this.$root.$emit) {
        this.$root.$emit('show-success', message);
      }
    };

    /**
     * Gestionnaire d'avertissement
     */
    Vue.prototype.$handleWarning = function(message) {
      if (this.$root.$emit) {
        this.$root.$emit('show-warning', message);
      }
    };
  }
};
